import { format } from "date-fns";

export class DateRange {
  constructor(
    private start: Date,
    private end: Date,
  ) {}

  public getStart(): Date {
    return this.start;
  }

  public getEnd(): Date {
    return this.end;
  }

  public getStartDateString(): string {
    return format(this.start, "yyyy-MM-dd");
  }

  public getEndDateString(): string {
    return format(this.end, "yyyy-MM-dd");
  }

  public getStartDateTimeString(): string {
    return format(this.start, "yyyy-MM-dd 00:00:01");
  }

  public getEndDateTimeString(): string {
    return format(this.end, "yyyy-MM-dd 23:59:59");
  }

  public getRangeString(): string {
    return (
      format(this.start, "MMM dd, yyyy") +
      " - " +
      format(this.end, "MMM dd, yyyy")
    );
  }

  public getRangeRequestParam(): string {
    return (
      format(this.start, "yyyy-MM-dd") + "," + format(this.end, "yyyy-MM-dd")
    );
  }
}
